import { c as n } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
const r = {
  wrapper: ({ theme: l, variant: i = "light" }) => /* @__PURE__ */ o([
    "display:flex;",
    ";"
  ], n({
    backgroundColor: l.componentColors.footer[i].background,
    paddingY: [
      "lg",
      null,
      "xl"
    ],
    paddingX: [
      "sm",
      "lg"
    ]
  })),
  content: ({ maxWidth: l = "eightColumnNoPadding" }) => /* @__PURE__ */ o([
    "",
    ""
  ], n({
    width: "100%",
    maxWidth: l,
    margin: "0 auto"
  })),
  linkList: ({ theme: l }) => /* @__PURE__ */ o([
    "",
    " ",
    ""
  ], l.resets.space, n({
    textAlign: [
      "center",
      null,
      "left"
    ],
    display: [
      "block",
      null,
      "inline"
    ]
  })),
  linkListItem: ({ theme: l }) => /* @__PURE__ */ o([
    "",
    " ",
    ""
  ], l.resets.list.item, n({
    display: [
      "list-item",
      null,
      "inline"
    ],
    marginBottom: [
      "18px",
      null,
      0
    ],
    marginRight: [
      0,
      null,
      "md"
    ]
  })),
  link: ({ theme: l, variant: i }) => /* @__PURE__ */ o([
    "color:",
    ";&:hover{color:",
    ";}"
  ], l.componentColors.footer[i].link.color, l.componentColors.footer[i].link.hover),
  icon: () => /* @__PURE__ */ o([
    "vertical-align:middle;margin-left:5px;"
  ]),
  copyright: () => /* @__PURE__ */ o([
    "",
    " white-space:pre-line;"
  ], n({
    marginTop: [
      "lg",
      null,
      "25px"
    ]
  }))
};
export {
  r as default
};
